import { ViteReactSSG } from 'vite-react-ssg/single-page'
import App from '@/App.tsx'
import '@/index.css'

// Modo single-page: vite-react-ssg genera el HTML estático en el build
// (prerendering) y lo hidrata en el cliente. Buscadores y motores de IA
// reciben todo el contenido ya renderizado, sin depender de JavaScript.
export const createRoot = ViteReactSSG(<App />)
